import { Component } from 'react';
import I18n from 'I18n';
import AssetActions from 'campaigns-lib/data/AssetActions';
import CampaignSelectFormControl from 'campaigns-lib/components/campaignSelect/CampaignSelectFormControl';
import { AssetTypes } from 'campaigns-lib/constants/AssetTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default class WorkflowCampaignSelect extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      selectedCampaigns: []
    };
    this.assetType = AssetTypes.WORKFLOW;
    this.handleChange = event => {
      const {
        onChange
      } = this.props;
      if (Array.isArray(event.target.value)) {
        this.setState({
          selectedCampaigns: event.target.value
        });
        if (onChange) {
          onChange(event);
        }
      }
    };
  }
  componentDidMount() {
    const {
      assetId,
      defaultCampaigns,
      onError,
      onMount,
      hasCampaignsReadAccess
    } = this.props;
    if (hasCampaignsReadAccess) {
      AssetActions[this.assetType].fetch(assetId).then(associatedCampaigns => {
        if (onMount) {
          onMount(associatedCampaigns);
        }
        this.setState({
          selectedCampaigns: defaultCampaigns || associatedCampaigns
        });
      }).catch(onError);
    }
  }
  render() {
    const {
      selectedCampaigns
    } = this.state;
    const {
      selectProps,
      formControlProps,
      hasCampaignsReadAccess,
      hasCampaignsWriteAccess
    } = this.props;
    if (!hasCampaignsReadAccess) {
      return null;
    }
    return /*#__PURE__*/_jsx(CampaignSelectFormControl, Object.assign({
      assetObjectType: "AUTOMATION_PLATFORM_FLOW",
      multi: true,
      hasCampaignsReadAccess: hasCampaignsReadAccess,
      hasCampaignsWriteAccess: hasCampaignsWriteAccess,
      formControlProps: formControlProps,
      withCampaignAutoSelectPopover: true,
      editorSelect: true,
      assetLabel: I18n.text('campaignSelect.workflowsLabel').toLowerCase(),
      value: selectedCampaigns,
      onChange: this.handleChange
    }, selectProps));
  }
}